// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.6;
  color: var(--text-dark);
  background-color: var(--bg-cream);
  min-height: 100vh;
  justify-content: center;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 2px solid var(--border-gray);
}

h1 {
  color: var(--primary-teal);
  margin-bottom: 8px;
  font-weight: 600;
}

.subtitle {
  color: var(--text-medium);
  font-size: 1.1rem;
}

/* Dual Architecture Showcase Styles */
.dual-architecture-showcase {
  background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);
  border-radius: 16px;
  padding: 32px;
  margin: 40px 0;
  color: white;
  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.2);
}

.showcase-header {
  text-align: center;
  margin-bottom: 28px;
}

.showcase-header h2 {
  color: var(--accent-mint);
  border-bottom: 2px solid var(--accent-mint);
  padding-bottom: 10px;
  margin-bottom: 14px;
  font-weight: 600;
}

.showcase-header p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 18px;
  color: var(--primary-teal);
  border-bottom: 2px solid var(--border-gray);
  padding-bottom: 8px;
  font-weight: 600;
}

/* Wallet container layout */
.wallet-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

.wallet-section,
.connection-section,
.wallet-details-section,
.transaction-section {
  background-color: var(--bg-white);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);
  transition: all 0.3s ease;
}

.wallet-section:hover,
.connection-section:hover,
.wallet-details-section:hover,
.transaction-section:hover {
  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);
}

.wallet-details-section,
.transaction-section {
  grid-column: span 2;
}

/* Wallet list */
.wallet-list {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid var(--border-gray);
  border-radius: 12px;
}

.wallet-section-header {
  font-weight: 600;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(42, 141, 156, 0.05) 100%);
  border-bottom: 1px solid var(--border-gray);
  color: var(--primary-teal);
}

.wallet-item {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid var(--border-gray);
  cursor: pointer;
  transition: all 0.3s ease;
}

.wallet-item:last-child {
  border-bottom: none;
}

.wallet-item:hover:not(.disabled) {
  background: linear-gradient(90deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);
  transform: translateX(4px);
}

.wallet-item img {
  width: 32px;
  height: 32px;
  margin-right: 16px;
  object-fit: contain;
  border-radius: 8px;
}

.wallet-item .status {
  margin-left: auto;
  font-size: 0.85rem;
  color: var(--text-medium);
  font-weight: 500;
}

.wallet-item .installed {
  color: var(--success);
}

/* Signature text in log */
.signature-text {
  word-break: break-all;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.85rem;
  background-color: rgba(17, 69, 77, 0.06);
  padding: 4px 8px;
  border-radius: 6px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--primary-teal);
}

#clear-log-button {
  background-color: var(--text-medium);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wallet-container {
    grid-template-columns: 1fr;
  }
  
  .wallet-details-section,
  .transaction-section {
    grid-column: span 1;
  }
}

/* Mobile specific styling */
.mobile-notice {
  background-color: #fff3cd;
  color: #856404;
  padding: 10px;
  border-left: 4px solid #ffeeba;
  margin-bottom: 15px;
  font-size: 0.9rem;
  line-height: 1.4;
  border-radius: 4px;
}

.mobile-view .wallet-container {
  grid-template-columns: 1fr;
}

.mobile-view .wallet-details-section,
.mobile-view .transaction-section {
  grid-column: span 1;
}

.mobile-view button {
  padding: 12px 20px;
  font-size: 1rem;
}

.mobile-view .wallet-list {
  max-height: 250px;
}

.mobile-view .wallet-item {
  padding: 12px;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  
  header {
    margin-bottom: 20px;
  }
  
  h1 {
    font-size: 1.5rem;
  }
  
  h2 {
    font-size: 1.1rem;
  }
  
  .wallet-item img {
    width: 25px;
    height: 25px;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .button-group button {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .event-log {
    height: 150px;
  }
}

.wallet-item .not-detected {
  color: var(--warning);
}

.wallet-item .unsupported {
  color: var(--error);
}

.wallet-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Connection status */
.status-container {
  margin-bottom: 24px;
}

.status {
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--primary-teal);
}

.address {
  font-size: 0.95rem;
  word-break: break-all;
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);
  padding: 12px;
  border-radius: 10px;
  font-family: 'Monaco', 'Menlo', monospace;
  border: 1px solid var(--border-gray);
  color: var(--text-dark);
}

/* Button styles */
button {
  background-color: var(--primary-teal);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);
}

button:hover:not(:disabled) {
  background-color: var(--primary-teal-light);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);
}

button:disabled {
  background-color: var(--border-gray);
  color: var(--text-light);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.button-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Wallet details */
.details-container {
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
  padding: 20px;
  border-radius: 12px;
  font-size: 0.95rem;
  border: 1px solid var(--border-gray);
}

.details-container dl {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 12px;
}

.details-container dt {
  font-weight: 600;
  color: var(--primary-teal);
}

.details-container dd {
  font-family: 'Monaco', 'Menlo', monospace;
  word-break: break-all;
  color: var(--text-dark);
}

/* Transaction section */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.balance {
  font-size: 1rem;
  margin-top: 12px;
  font-weight: 600;
  color: var(--primary-teal);
}

/* Loading state for balance */
.balance.loading {
  color: var(--text-medium);
  position: relative;
  padding-left: 24px;
}

.balance.loading::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-gray);
  border-top-color: var(--primary-teal);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

/* Event log */
.log-section {
  background-color: var(--bg-white);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);
  transition: all 0.3s ease;
}

.log-section:hover {
  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);
}

.event-log {
  height: 220px;
  overflow-y: auto;
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 14px;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.9rem;
  margin-bottom: 12px;
}

.log-entry {
  margin-bottom: 8px;
  padding: 8px;
  border-bottom: 1px solid var(--border-gray);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.log-entry:hover {
  background-color: rgba(17, 69, 77, 0.03);
}

.log-timestamp {
  color: var(--text-medium);
  font-size: 0.85rem;
  margin-right: 8px;
}

.log-type-info {
  color: var(--primary-teal);
}

.log-type-error {
  color: var(--error);
}

.log-type-warning {
  color: var(--warning);
}

.log-type-success {
  color: var(--success);
}

/* Extended components styling */
.extended-components {
  margin-bottom: 32px;
}

.component-row {
  margin-bottom: 24px;
}

.token-components {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 768px) {
  .token-components {
    grid-template-columns: 1fr;
  }
}

.wallet-index {
  margin-right: 6px;
  color: var(--primary-teal);
  font-weight: 600;
}

.adapter-methods {
  margin-top: 24px;
}

.adapter-methods h3 {
  font-size: 1.1rem;
  margin-bottom: 12px;
  color: var(--primary-teal);
}

.adapter-methods ul {
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.adapter-methods li {
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.08) 0%, rgba(95, 184, 165, 0.08) 100%);
  padding: 6px 12px;
  border-radius: 8px;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.9rem;
  color: var(--primary-teal);
  border: 1px solid var(--border-gray);
  transition: all 0.3s ease;
}

.adapter-methods li:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(17, 69, 77, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gGAAgG;EAChG,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,4FAA4F;EAC5F,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;EAIE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;;;EAIE,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6FAA6F;EAC7F,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4FAA4F;EAC5F,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,0CAA0C;EAC5C;AACF;;AAEA,cAAc;AACd;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6FAA6F;EAC7F,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,6FAA6F;EAC7F,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C","sourcesContent":["/* Base styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  line-height: 1.6;\n  color: var(--text-dark);\n  background-color: var(--bg-cream);\n  min-height: 100vh;\n  justify-content: center;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\nheader {\n  text-align: center;\n  margin-bottom: 40px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid var(--border-gray);\n}\n\nh1 {\n  color: var(--primary-teal);\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.subtitle {\n  color: var(--text-medium);\n  font-size: 1.1rem;\n}\n\n/* Dual Architecture Showcase Styles */\n.dual-architecture-showcase {\n  background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);\n  border-radius: 16px;\n  padding: 32px;\n  margin: 40px 0;\n  color: white;\n  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.2);\n}\n\n.showcase-header {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.showcase-header h2 {\n  color: var(--accent-mint);\n  border-bottom: 2px solid var(--accent-mint);\n  padding-bottom: 10px;\n  margin-bottom: 14px;\n  font-weight: 600;\n}\n\n.showcase-header p {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1.1rem;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\nh2 {\n  font-size: 1.5rem;\n  margin-bottom: 18px;\n  color: var(--primary-teal);\n  border-bottom: 2px solid var(--border-gray);\n  padding-bottom: 8px;\n  font-weight: 600;\n}\n\n/* Wallet container layout */\n.wallet-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.wallet-section,\n.connection-section,\n.wallet-details-section,\n.transaction-section {\n  background-color: var(--bg-white);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);\n  transition: all 0.3s ease;\n}\n\n.wallet-section:hover,\n.connection-section:hover,\n.wallet-details-section:hover,\n.transaction-section:hover {\n  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);\n}\n\n.wallet-details-section,\n.transaction-section {\n  grid-column: span 2;\n}\n\n/* Wallet list */\n.wallet-list {\n  max-height: 320px;\n  overflow-y: auto;\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n}\n\n.wallet-section-header {\n  font-weight: 600;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(42, 141, 156, 0.05) 100%);\n  border-bottom: 1px solid var(--border-gray);\n  color: var(--primary-teal);\n}\n\n.wallet-item {\n  display: flex;\n  align-items: center;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--border-gray);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.wallet-item:last-child {\n  border-bottom: none;\n}\n\n.wallet-item:hover:not(.disabled) {\n  background: linear-gradient(90deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);\n  transform: translateX(4px);\n}\n\n.wallet-item img {\n  width: 32px;\n  height: 32px;\n  margin-right: 16px;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.wallet-item .status {\n  margin-left: auto;\n  font-size: 0.85rem;\n  color: var(--text-medium);\n  font-weight: 500;\n}\n\n.wallet-item .installed {\n  color: var(--success);\n}\n\n/* Signature text in log */\n.signature-text {\n  word-break: break-all;\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.85rem;\n  background-color: rgba(17, 69, 77, 0.06);\n  padding: 4px 8px;\n  border-radius: 6px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--primary-teal);\n}\n\n#clear-log-button {\n  background-color: var(--text-medium);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .wallet-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .wallet-details-section,\n  .transaction-section {\n    grid-column: span 1;\n  }\n}\n\n/* Mobile specific styling */\n.mobile-notice {\n  background-color: #fff3cd;\n  color: #856404;\n  padding: 10px;\n  border-left: 4px solid #ffeeba;\n  margin-bottom: 15px;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  border-radius: 4px;\n}\n\n.mobile-view .wallet-container {\n  grid-template-columns: 1fr;\n}\n\n.mobile-view .wallet-details-section,\n.mobile-view .transaction-section {\n  grid-column: span 1;\n}\n\n.mobile-view button {\n  padding: 12px 20px;\n  font-size: 1rem;\n}\n\n.mobile-view .wallet-list {\n  max-height: 250px;\n}\n\n.mobile-view .wallet-item {\n  padding: 12px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n  \n  header {\n    margin-bottom: 20px;\n  }\n  \n  h1 {\n    font-size: 1.5rem;\n  }\n  \n  h2 {\n    font-size: 1.1rem;\n  }\n  \n  .wallet-item img {\n    width: 25px;\n    height: 25px;\n  }\n  \n  .button-group {\n    flex-direction: column;\n  }\n  \n  .button-group button {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n  \n  .event-log {\n    height: 150px;\n  }\n}\n\n.wallet-item .not-detected {\n  color: var(--warning);\n}\n\n.wallet-item .unsupported {\n  color: var(--error);\n}\n\n.wallet-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Connection status */\n.status-container {\n  margin-bottom: 24px;\n}\n\n.status {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--primary-teal);\n}\n\n.address {\n  font-size: 0.95rem;\n  word-break: break-all;\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);\n  padding: 12px;\n  border-radius: 10px;\n  font-family: 'Monaco', 'Menlo', monospace;\n  border: 1px solid var(--border-gray);\n  color: var(--text-dark);\n}\n\n/* Button styles */\nbutton {\n  background-color: var(--primary-teal);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);\n}\n\nbutton:hover:not(:disabled) {\n  background-color: var(--primary-teal-light);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);\n}\n\nbutton:disabled {\n  background-color: var(--border-gray);\n  color: var(--text-light);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.button-group {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Wallet details */\n.details-container {\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n  padding: 20px;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  border: 1px solid var(--border-gray);\n}\n\n.details-container dl {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 12px;\n}\n\n.details-container dt {\n  font-weight: 600;\n  color: var(--primary-teal);\n}\n\n.details-container dd {\n  font-family: 'Monaco', 'Menlo', monospace;\n  word-break: break-all;\n  color: var(--text-dark);\n}\n\n/* Transaction section */\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.balance {\n  font-size: 1rem;\n  margin-top: 12px;\n  font-weight: 600;\n  color: var(--primary-teal);\n}\n\n/* Loading state for balance */\n.balance.loading {\n  color: var(--text-medium);\n  position: relative;\n  padding-left: 24px;\n}\n\n.balance.loading::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-gray);\n  border-top-color: var(--primary-teal);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n\n/* Event log */\n.log-section {\n  background-color: var(--bg-white);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);\n  transition: all 0.3s ease;\n}\n\n.log-section:hover {\n  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);\n}\n\n.event-log {\n  height: 220px;\n  overflow-y: auto;\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 14px;\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.9rem;\n  margin-bottom: 12px;\n}\n\n.log-entry {\n  margin-bottom: 8px;\n  padding: 8px;\n  border-bottom: 1px solid var(--border-gray);\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.log-entry:hover {\n  background-color: rgba(17, 69, 77, 0.03);\n}\n\n.log-timestamp {\n  color: var(--text-medium);\n  font-size: 0.85rem;\n  margin-right: 8px;\n}\n\n.log-type-info {\n  color: var(--primary-teal);\n}\n\n.log-type-error {\n  color: var(--error);\n}\n\n.log-type-warning {\n  color: var(--warning);\n}\n\n.log-type-success {\n  color: var(--success);\n}\n\n/* Extended components styling */\n.extended-components {\n  margin-bottom: 32px;\n}\n\n.component-row {\n  margin-bottom: 24px;\n}\n\n.token-components {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n@media (max-width: 768px) {\n  .token-components {\n    grid-template-columns: 1fr;\n  }\n}\n\n.wallet-index {\n  margin-right: 6px;\n  color: var(--primary-teal);\n  font-weight: 600;\n}\n\n.adapter-methods {\n  margin-top: 24px;\n}\n\n.adapter-methods h3 {\n  font-size: 1.1rem;\n  margin-bottom: 12px;\n  color: var(--primary-teal);\n}\n\n.adapter-methods ul {\n  list-style-type: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.adapter-methods li {\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.08) 0%, rgba(95, 184, 165, 0.08) 100%);\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.9rem;\n  color: var(--primary-teal);\n  border: 1px solid var(--border-gray);\n  transition: all 0.3s ease;\n}\n\n.adapter-methods li:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(17, 69, 77, 0.15);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
